import React from 'react';

const Footer: React.FC = () => {
  return (
      <footer className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-4 md:hidden z-50">
        <div className="max-w-[52rem] w-full mx-auto">
          <div className="flex justify-center space-x-4">
            <a
                className="relative group inline-flex justify-center items-center w-10 h-10 text-gray-500 hover:text-[#F52549] hover:bg-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-[#EA738D] focus:ring-offset-2 focus:ring-offset-white transition"
                href="https://github.com/ambisuzanne"
                target="_blank"
                rel="noopener noreferrer"
            >
              <i className="text-xl fab fa-github"></i>
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-white px-2 py-1 text-xs rounded-md text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">GitHub</span>
            </a>
            <a
                className="relative group inline-flex justify-center items-center w-10 h-10 text-gray-500 hover:text-[#F52549] hover:bg-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-[#EA738D] focus:ring-offset-2 focus:ring-offset-white transition"
                href="https://www.linkedin.com/in/ambi-suzanne-brenner/"
                target="_blank"
                rel="noopener noreferrer"
            >
              <i className="text-xl fab fa-linkedin"></i>
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-white px-2 py-1 text-xs rounded-md text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">LinkedIn</span>
            </a>
            <a
                className="relative group inline-flex justify-center items-center w-10 h-10 text-gray-500 hover:text-[#F52549] hover:bg-gray-100 rounded-full focus:outline-none focus:ring-2 focus:ring-[#EA738D] focus:ring-offset-2 focus:ring-offset-white transition"
                href="https://www.power3designs.com"
                target="_blank"
                rel="noopener noreferrer"
            >
              <i className="text-xl fas fa-globe"></i>
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 bg-white px-2 py-1 text-xs rounded-md text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">Power3 Designs</span>
            </a>
          </div>
        </div>
      </footer>
  );
};

export default Footer;